export const ORDER_AUTH_BROADCAST_CHANNEL = 'order-auth-broadcast-channel';

export const BROADCAST_EVENTS = {
  LOG_IN: 'broadcast-event-log-in',
  LOG_OUT: 'broadcast-event-log-out',
};
